export default "/images/project3.jpg?4ab38f26bf7dbf8a5ef9e5ae3363e676";